import React from "react";
//import NipLogo from "./../../../../assets/nip-tag.svg";
import NIP from "./../../../../assets/NIP.svg";

export const Nip = ({ className, isValidProject }) => {
  return isValidProject ? (
    <div className={className}>
      <img src={NIP} />
    </div>
  ) : null;
};
